<script>
  export default {
    name: 'RedemptionSubmit',

    props: {
      value: {
        required: true,
      },
    },

    data: () => ({
      showDialog: false,
    }),

    watch: {
      value: {
        immediate: true,
        handler(value) {
          this.showDialog = value;
        },
      },
    },

    methods: {
      closeDialog() {
        this.showDialog = false;
      },
      goToTransactionPage() {
        this.closeDialog();
        this.changeDialogState();
        this.$router.push('/profileuser/history');
      },
      changeDialogState(value = false) {
        this.$store.dispatch('setWalletDialog', {
          value,
          tab: 'purchase',
        });
      },
    },
  };
</script>

<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    hide-overlay
    content-class="fixed-right alert-dialog alert-shadow rounded-borders-5"
    @click:outside="closeDialog()"
    @keydown.esc="closeDialog()"
  >
    <v-card min-height="190px" class="d-flex flex-column justify-center align-center position-relative">
      <v-icon size="36" color="white" @click="closeDialog">mdi-close</v-icon>

      <v-card-title class="justify-center flex-column mt-5 alert-dialog-title">
        <span class="white--text font-size-26 font-weight-bold wrapped-text">Redemption Submitted</span>
      </v-card-title>
      <v-card-text class="white--text text-center font-size-20 font-weight-semi">
        Your request will be processed in the next 24 hours.
        <br />
        Check the status from your Transaction History Page
      </v-card-text>
      <v-btn class="transaction-btn border-single mb-5" @click="goToTransactionPage">TRANSACTION HISTORY</v-btn>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
  .transaction-btn::v-deep {
    .v-btn__content {
      color: black !important;
    }
  }

  .wrapped-text {
    overflow-wrap: break-word;
    white-space: normal;
    text-align: center;

    @media screen and (max-width: 400px) {
      font-size: 24px !important;
    }
  }

  .alert-dialog-title {
    @media screen and (max-width: 400px) {
      padding: 0 10px !important;
    }
  }

  .alert-dialog {
    box-shadow: 1px 1px 5px #000000 !important;

    .v-card {
      background: rgb(67, 37, 89);
      background: linear-gradient(-35deg, rgba(67, 37, 89, 1) 27%, rgba(135, 121, 182, 1) 100%);

      .v-icon {
        position: absolute;
        right: 15px;
        top: 15px;
      }

      span {
        word-break: break-word;
      }
    }
  }
</style>

<!-- Warning. Global style -->
<style>
  @media screen and (max-width: 400px) {
    .v-dialog.alert-dialog {
      margin: 5px !important;
    }
  }
</style>
